import { IonInput } from "@ionic/react";

export type EditableInputProps = {
  value?: string;
  label?: string;
  placeholder?: string;
  onChange?: (change: CustomEvent) => void;
};

export const EditableInput: React.FC<EditableInputProps> = ({
  value,
  placeholder,
  onChange,
  label,
}) => {
  return (
    <IonInput
      value={value}
      placeholder={placeholder}
      onIonInput={onChange}
      labelPlacement="stacked"
    >
      <div slot="label" className="font-medium">
        {label}
      </div>
    </IonInput>
  );
};
